import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { Config } from "../../models";

export type ConfigStore = {
  config?: Config;
  setConfig: (config: Config) => void;
};

export const useConfigStore = create<ConfigStore>()(
  devtools(
    (set) => ({
      setConfig: (config) =>
        set(() => ({
          config,
        })),
    }),
    {
      name: "ConfigGroupActionsStore",
    },
  ),
);

export const useGetConfig = () => {
  const { config } = useConfigStore.getState();
  if (!config) throw new Error("No config found");

  return config;
};

export const useGetSlug = () => {
  const config = useGetConfig();

  return config.slug;
};
